import PaymentSummary from './PaymentSummary';

const pad = (num: number) => {
  return ('00' + num).slice(-2);
};

class PaymentHistory {
  public readonly monthly: Map<string, Map<string, PaymentSummary[]>>;
  public readonly monthlyRate: Map<string, number>;
  public readonly monthlyPayeeName: Map<string, string>;
  public readonly monthlyPayeeInvoiceNumber: Map<string, string>;
  constructor({
    monthly,
    monthlyRate,
    monthlyPayeeName,
    monthlyPayeeInvoiceNumber,
  }: {
    monthly: Map<string, Map<string, PaymentSummary[]>>;
    monthlyRate: Map<string, number>;
    monthlyPayeeName: Map<string, string>;
    monthlyPayeeInvoiceNumber: Map<string, string>;
  }) {
    this.monthly = monthly;
    this.monthlyRate = monthlyRate;
    this.monthlyPayeeName = monthlyPayeeName;
    this.monthlyPayeeInvoiceNumber = monthlyPayeeInvoiceNumber;
  }

  public static fromJSON = (value: any) => {
    if (typeof value !== 'object') throw new TypeError('monthly_total data struct is invalid');

    const monthly = new Map<string, Map<string, PaymentSummary[]>>();
    const monthlyRate = new Map<string, number>();
    const monthlyPayeeName = new Map<string, string>();
    const monthlyPayeeInvoiceNumber = new Map<string, string>();

    value.forEach((data: any) => {
      ['all', 'pending', 'fixed', 'failed', 'paid'].forEach((key: any) => {
        const mm = data[key];
        if (!mm) return;
        if (typeof mm !== 'object') throw new TypeError(`monthly_total ${key} data struct is invalid`);
        mm.forEach((m: any) => {
          const month = new Date(Date.parse(m.data.service_month));
          if (month.toString() === 'Invalid Date') throw new TypeError('all service_month must be a Date');
          const monthStr = `${month.getFullYear()}${pad(month.getMonth() + 1)}`;
          if (!monthly.get(monthStr)) {
            monthly.set(monthStr, new Map<string, PaymentSummary[]>());
            monthlyRate.set(monthStr, data['from_usd_to_jpy_exchange_currency_rate']);
            monthlyPayeeName.set(monthStr, data['payment_user']?.['username']);
            monthlyPayeeInvoiceNumber.set(monthStr, data['payment_user']?.['invoice_number']);
          }
          const monthlySummaries_ = monthly.get(monthStr);
          if (monthlySummaries_) {
            if (!monthlySummaries_.get(key)) {
              monthlySummaries_.set(key, []);
            }
            const monthlySummaries = monthlySummaries_.get(key);
            if (monthlySummaries) {
              monthlySummaries.push(PaymentSummary.fromJSON(m.data));
            }
          }
        });
      });
    });

    return new PaymentHistory({
      monthly,
      monthlyRate,
      monthlyPayeeName,
      monthlyPayeeInvoiceNumber,
    });
  };
}

export default PaymentHistory;
